<template>
    <div class="topbar-container">
        <zbView :isEmpty="!addressList.length" class="buy-container" @reLoad="loadList(true)">
            <div class="line"></div>
            <div class="address-list">
                <div
                    v-for="(item,i) in addressList"
                    :key="i"
                    @click="onSelectClick(item)"
                    class="address-list-item border-bottom"
                >
                    <van-swipe-cell :before-close="beforeClose">
                        <div class="item bh bstart">
                            <div class="bg-contain ico-location"></div>
                            <div class="b1">
                                <div class="bh bstart fz_30">
                                    <div class="name">{{item.contact}}</div>
                                    {{item.telephone}}
                                </div>
                                <div class="address fz_28 bh bstart breakword">
                                    <div class="def fz_24 r4" v-if="item.isDefault">默认</div>
                                    <div class="bh b1 defaultText"> {{item.allAddress}}</div>
                                </div>
                            </div>
                            <div class="btn-container" @click.stop="onEditClick(item.id)">
                                <div class="bg-contain ico-edit"></div>
                            </div>
                        </div>
                        <template slot="right">
                            <div class="bh bc swipe-right">
                                <van-button
                                    @click="onDelClick(item.id)"
                                    class="r6"
                                    type="danger"
                                    size="small"
                                    text="删除"
                                />
                            </div>
                        </template>
                    </van-swipe-cell>
                </div>
            </div>
            <div class="line"></div>
        </zbView>
        <div class="buybar bh bc">
            <!-- 最多只能有20个收货地址 -->
            <van-button
                class="btn btn-goodbuy bh bc"
                :disabled="addressList.length>=20"
                @click="onAddClick"
            >
                <div class="bh bc">
                    <div class="ico-whiteAdd btn-ico-el"></div>新增收货地址
                </div>
            </van-button>
        </div>
    </div>
</template>

<script>
import { user } from "@/mixin/user";
import { routeCache } from "@/mixin/cache";
import zbView from "@/components/data/View";
import { addressDel } from "@/api/user";
export default {
    mixins: [user, routeCache],
    name: "UserAddressHome",
    components: { zbView },
    data() {
        return {
            // 当前是否是购买状态
            isBuy: false
        };
    },
    computed: {
        addressList() {
            return this.$store.state.cart.addressList;
        }
    },
    methods: {
        loadList(is = false) {
            this.$store.dispatch("cart/addressList", is);
        },
        userLoginend() {
            this.loadList();
            // 当前购买状态标识
            this.isBuy = this.getCache().isBuy;
            console.log(this.addressList)
        },
        // 新增
        onAddClick() {
            this.go("UserAddressEdit", {
                isEdit: false
            });
        },
        // 编辑
        onEditClick(id) {
            this.go("UserAddressEdit", {
                isEdit: true,
                id: id
            });
        },
        onSelectClick(item) {
            const me = this;
            // 根据是否购买状态确定交互逻辑
            if (me.isBuy) {
                // 选择地址
                me.$store.state.cart.address = item;
                me.$store.state.cart.isSelectAddress = true;
                me.$router.go(-1);
            } else {
                // 编辑
                me.onEditClick(item.id);
            }
        },
        onDelClick(id) {
            this.id = id;
        },
        // position 为关闭时点击的位置
        // instance 为对应的 SwipeCell 实例
        beforeClose({ position, instance }) {
            const me = this,
                id = me.id;

            switch (position) {
                case "outside":
                    instance.close();
                    break;
                case "right":
                    if (id) {
                        me.dialog
                            .confirm({
                                message: "确定删除吗？"
                            })
                            .then(() => {
                                instance.close();
                                addressDel(id).then(res => {
                                    me.loadList(true);
                                });
                            });
                    }
                    break;
            }
        }
    }
};
</script>

<style scoped lang="scss">
.buy-container {
    background: #f1f2f3;
}
.btn-goodbuy {
    width: 510px;
}
.btn-ico-el {
    margin-right: 10px;
}
.btn-container {
    padding: 20px;
}
.swipe-right {
    height: 100%;
}
.address-list .def{
    width: 60px;
    padding:4px 5px;
    text-align: center;
}
.defaultText{
    padding-top: 0px;
}
</style>

